import React from 'react';
import PropTypes from 'prop-types';
import Section from 'components/common/Section';
import Process from './Process';
import SectionHeader from './SectionHeader';
import { isIterableArray } from 'helpers/utils';
import is from 'is_js';
import { getConfigFromConfigsByKey } from 'y4/Falcon';
import _ from 'lodash';

const Processes = ({ configs }) => {
  if (is.empty(configs)) return null;
  const c = getConfigFromConfigsByKey(configs, 'LandingProcess');
  const pl = configs
    .filter(p => p.key == 'LandingProcessItem')
    .map((p, i) => {
      return {
        icon: _.get(p, 'extension.icon'),
        iconText: p.code,
        color: _.get(p, 'extension.color'),
        title: p.title,
        description: p.caption,
        image: p.imageUrl,
        inverse: i % 2 == 1
      };
    });
  return (
    <Section>
      {c && <SectionHeader title={c.title} subtitle={c.caption} />}
      {isIterableArray(pl) &&
        pl.map((process, index) => (
          <Process key={index} isFirst={index === 0} {...process} />
        ))}
    </Section>
  );
};
Processes.propTypes = {
  configs: PropTypes.array
};
export default Processes;
